<template>
  <dropdown
    class="datepicker-dropdown-center"
    :class="{ 'form-group': formGroup }"
    :style="{ marginBottom: formGroupMarginBottom && formGroup ? '15px' : null }"
  >
    <label v-if="title">{{ title }}</label>
    <slot :value="value">
      <div class="input-group">
        <!--
          Вызывается при изменении значения.

          @event input
          @property {String} value Дата.
        -->
        <input
          v-mask="$getConst('DATE_INPUT_MASK')"
          :value="value"
          :disabled="disabled"
          class="form-control"
          :class="{ 'text-bold': bold }"
          :style="{ width }"
          type="text"
          @input="$emit('input', $event.target.value)"
        >
        <div class="input-group-btn">
          <btn
            class="dropdown-toggle"
            :disabled="disabled"
          >
            <i class="glyphicon glyphicon-calendar" />
          </btn>
        </div>
      </div>
    </slot>
    <span
      v-if="helpText"
      class="help-block"
      v-text="helpText"
    />
    <template v-slot:dropdown>
      <li>
        <date-picker
          :value="value"
          :today-btn="false"
          :clear-btn="false"
          :limit-from="limitFrom"
          :limit-to="limitToCurrent ? limitToCurrentDate : limitTo"
          :locale="localeRU"
          :date-parser="dateParser"
          format="dd-MM-yyyy"
          @input="$emit('input', $event)"
        />
      </li>
    </template>
  </dropdown>
</template>

<script>
import { DatePicker, Dropdown, Btn } from 'uiv'
import localeRU from 'uiv/src/locale/lang/ru-RU'
import moment from 'moment'

export default {
  name: 'CDatePicker',
  components: {
    Dropdown,
    Btn,
    DatePicker
  },
  props: {
    /**
     * Текущее значение.
     *
     * @model
     */
    value: {
      type: String,
      required: true
    },
    /**
     * Текст лейбла.
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Обернуть ли input в div.form-group.
     */
    formGroup: {
      type: Boolean,
      default: false
    },
    /**
     * Отступ снизу от div.form-group.
     */
    formGroupMarginBottom: {
      type: Boolean,
      default: false
    },
    /**
     * Доступно ли изменение значения.
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Левая граница выбора даты.
     */
    limitFrom: {
      validator (value) {
        return ['object', 'string', 'number'].includes(typeof value) || value === null
      },
      default: null
    },
    /**
     * Правая граница выбора даты.
     */
    limitTo: {
      validator (value) {
        return ['object', 'string', 'number'].includes(typeof value) || value === null
      },
      default: null
    },
    /**
     * Ограничить ли правую границу текущей датой.
     */
    limitToCurrent: {
      type: Boolean,
      default: false
    },
    /**
     * Нужно ли выделить жирным текст значения.
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Текст под input-ом.
     */
    helpText: {
      type: String,
      default: ''
    },
    /**
     * Ширина input-а на разрешениях до 768px.
     */
    width: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      localeRU
    }
  },
  computed: {
    limitToCurrentDate () {
      return moment().add(1, 'day')
    }
  },
  methods: {
    dateParser (date) {
      return moment(date, this.$getConst('DATE_INPUT_FORMAT')).valueOf()
    }
  }
}
</script>

<style scoped>
.help-block {
  font-weight: lighter;
}
</style>
